import api from "@services/api";

/** localStorage entry the maps read the Google key from */
export const GOOGLE_KEY_STORAGE = "@Fleet:google";

/**
 * Read the client's Google key from the server (reg_params "google") and cache it for the maps.
 * Called on every login, so a key changed in reg_params reaches the user on the next login.
 * There is no fallback key: when the server gives none, the cached key (if any) is kept and the error is logged.
 * @returns The key now cached, or null when there is none
 */
export const refreshGoogleMapsKey = async (): Promise<string | null> => {
  try {
    const { data } = await api.get("params/read/google");
    const key = data?.status === "success" ? data.result?.[0]?.key : undefined;

    if (key) {
      localStorage.setItem(GOOGLE_KEY_STORAGE, key);

      return key;
    }

    console.error("Google key not found in params (google)");
  } catch (error) {
    console.error("Error loading the Google key:", error);
  }

  return localStorage.getItem(GOOGLE_KEY_STORAGE);
};
